import React, { createContext, PropsWithChildren, useContext } from 'react';
import { Col, ColProps } from 'reactstrap';
import { useResponsiveListDetail, ViewType } from '../../hook/useResponsiveListDetail';

interface ResponsiveContextProviderProps extends PropsWithChildren<{}> {
  single: boolean;
  selectedId?: string;
}

interface ResponsiveContextValue {
  single: boolean;

  listProps: ColProps;
  detailProps: ColProps;
  setViewType: (viewType: ViewType) => void;
}

const ResponsiveContext = createContext<ResponsiveContextValue>(null!);

/**
 * Provides responsive context for responsive components coupling
 */
export function ResponsiveContextProvider({ single, selectedId, children }: ResponsiveContextProviderProps) {
  const [listProps, detailProps, setViewType] = useResponsiveListDetail(single, selectedId);
  return (
    <ResponsiveContext.Provider value={{ single, listProps, detailProps, setViewType }}>
      {children}
    </ResponsiveContext.Provider>
  );
}

/**
 * Responsive column for list
 */
export function ResponsiveListCol({ children }: PropsWithChildren<{}>) {
  const { listProps } = useContext(ResponsiveContext);
  return <Col {...listProps}>{children}</Col>;
}

/**
 * Responsive column for detail
 */
export function ResponsiveDetailCol({ children }: PropsWithChildren<{}>) {
  const { detailProps } = useContext(ResponsiveContext);
  return <Col {...detailProps}>{children}</Col>;
}

export interface ResponsiveBackToListColProps extends ColProps {}

/**
 * Responsive column for icon navigating "back to list"
 */
export function ResponsiveBackToListCol({ children, ...rest }: ResponsiveBackToListColProps) {
  const { single } = useContext(ResponsiveContext);

  if (single) {
    // no content for single record view (only DETAIL)
    return null;
  }

  return <Col {...rest}>{children}</Col>;
}
